/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'assets/js/modules/View',
        'assets/js/modules/option/optionModel',
        'assets/js/modules/option/optionValueModel',
        'assets/js/modules/pages/start/view/productTabsView',
        'assets/js/modules/pages/start/view/pricingDeliveryView',
        'assets/js/modules/widgets/mailingService/mailingServiceWidgetView',
        'assets/js/modules/widgets/uploadInfo/uploadInfoWidgetView',
        'assets/js/modules/widgets/startFiles/startFileWidgetView',
        'assets/js/common/storage/permanent',
        'selectboxit/src/javascripts/jquery.selectBoxIt.min',
        'jquery.scrollto'
    ],
    function(
        $,
        View,
        OptionModel,
        OptionValueModel,
        ProductTabsView,
        PricingDeliveryView,
        MailingServiceWidgetView,
        UploadInfoWidgetView,
        StartFileWidgetView,
        storage
    ) {
        return View.extend({
            events: {
                'click #upload-page-btn, #upload-button': 'goToUploadPage',
                'click .proceed-design-btn': 'proceed',
                'click .show-more-templates': 'scrollToGallery',
                'change #mailing-service-select': 'updateMailingServiceOption',
                'change #mailing-service-switch': 'updateMailingServiceOptionNewProduct'
            },

            initialize: function(options) {
                storage.getInstance().removeItem(OptionModel.NAME_MAILING_SERVICE);
                var _this = this;

                this.$mailingServiceBlock = this.$el.find('#mailing-service-block');
                this.$mailingServiceContainer = this.$el.find('#mailing-service-container');
                this.$mailingServiceSelect = this.$el.find('#mailing-service-select');
                this.$mailingServiceSwitch = this.$el.find('#mailing-service-switch');
                this.$mailingServiceSwitchBlock = this.$el.find('.mailing-service-switch-block');

                if (this.model.get('handleBannerClicks')) {
                    this.$el.on('click', '.designer-banner, .main-banner-container, .main-banner > .image', function() {
                        _this.goToGalleryPage();
                    });

                    this.$el.on('click', '.mobile-action-toolbar', function(e) {
                        e.preventDefault();
                        _this.goToGalleryPage();
                    });
                } else {
                    this.$el.find('.main-banner-container').removeClass('clickable-banner');
                    this.$el.find('.image').removeClass('hover-pointer');

                    this.$el.on('click', '.banner-start-btn', function() {
                        _this.goToGalleryPage();
                    });
                }

                this.$el.on('click', '.js-banner-button', function(e) {
                    e.stopPropagation();
                    if ($(this).attr('href').length === 0) {
                        e.preventDefault();
                        _this.goToGalleryPage();
                    }
                });

                this.listenTo(this.model, {
                    'change:template': function(model) {
                        //hide banner when template is chosen first time
                        if (model.previous('template') === null) {
                            _this.hideBanner();
                        }
                        $(window).scrollTo(0, 500);
                    },
                    'change:startFileWidgetModel': function() {
                        new StartFileWidgetView({
                            model: _this.model.get('startFileWidgetModel'),
                            el: '.start-files-widget'
                        });
                    },
                    'PricingCalcItem:changed': this.updateMailingServiceContainer
                });

                this.listenTo(this.model.get('eventAgent'), {
                    'PricingCalculator:changed': function(pricingCalcItem, isSkuChanged, isOptionSetChanged, isSideCountChanged) {
                        if (isSkuChanged) {
                            _this.updateDelivery();
                        }
                    }
                });

                this.listenTo(this.model.get('mailingService'), {
                    'change:quantity': this.updateDelivery
                });

                if (this.model.get('showProductTabs')) {
                    this.initProductTabsView();
                }

                this.mailingServiceWidgetView = new MailingServiceWidgetView({
                    model: this.model.get('mailingService'),
                    el: '#mailing-service-widget'
                });

                this.initPricingDeliveryView();

                if (this.model.get('showDvsDesigner')) {
                    this.initDvsDesigner();
                }

                if (this.model.get('showGallery')) {
                    this.initTemplateGallery();
                }

                if (this.model.get('showUploadInfo')) {
                    this.initUploadInfo();
                }
            },

            initProductTabsView: function() {
                new ProductTabsView({
                    model: this.model,
                    el: this.$el,
                    tabsContainer: '.prod-tabs',
                    tabsContent: '.tab-content',
                    activeTab: '.active [data-toggle="tab"]',
                    initPricingOnTabChange: true
                });
            },

            initPricingDeliveryView: function() {
                new PricingDeliveryView({
                    model: this.model,
                    el: this.$el.find('.pricing')
                });
            },

            initDvsDesigner: function() {
                var _this = this;
                require(['assets/js/modules/pages/start/view/dvsDesignerView'], function(DvsDesignerView) {
                    _this.dvsView = new DvsDesignerView({
                        model: _this.model,
                        el: '#dvs-designer-section'
                    });
                    _this.$el.one('click', '#dvs-designer-section', function() {
                        _this.hideBanner();
                        $(window).scrollTo(0, 400);
                    });
                });
            },

            initUploadInfo: function() {
                var _this = this;
                this.listenTo(this.model.get('eventAgent'), {
                    'StartPage:setProducts': function() {
                        _this.createUploadInfoWidgetView();
                    }
                });
            },

            /**
             * @return {UploadInfoWidgetView}
             */
            createUploadInfoWidgetView: function() {
                return new UploadInfoWidgetView({
                    el: '#upload-info-preview',
                    model: this.model.get('product'),
                    collection: this.model.get('products')
                });
            },

            initTemplateGallery: function() {
                var _this = this;
                this.listenTo(this.model.get('gallery'), {
                    'Gallery:changeTemplates': function() {
                        _this.onTemplatesChange();
                    }
                });
                require(['assets/js/modules/widgets/gallery/view/galleryView'], function(GalleryView) {
                    new GalleryView({
                        model: _this.model.get('gallery'),
                        el: '.gallery-wrapper'
                    });
                });

                if (_this.model.get('handleBannerClicks')) {
                    _this.$el.on('click', '.designer-banner, .main-banner-container', function() {
                        _this.goToGalleryPage();
                    });
                }
            },

            onTemplatesChange: function() {
                if (this.model.get('gallery').get('templates').length) {
                    this.$el.find('.show-more-templates').show();
                } else {
                    this.$el.find('.show-more-templates').hide();
                }
            },

            goToUploadPage: function() {
                this.model.get('eventAgent').trigger('goToUploadPage');
            },

            goToGalleryPage: function() {
                this.model.get('eventAgent').trigger('goToGalleryPage');
            },

            proceed: function(event) {
                event.preventDefault();
                if (this.dvsView) {
                    this.dvsView.approve();
                } else {
                    this.goToGalleryPage();
                }
            },

            scrollToGallery: function() {
                $(window).scrollTo($('.gallery-wrapper').offset().top - this.getFixedHeaderHeight(), 500);
            },

            hideBanner: function() {
                this.$el.find('.main-banner-container').hide();
            },

            cleanMailingServiceForce: function() {
                this.$mailingServiceSwitch.prop('checked', false);
                this.mailingServiceWidgetView.clearQuantity();
                this.mailingServiceWidgetView.renderQuantity();
            },

            updateMailingServiceContainer: function() {
                if (this.$mailingServiceBlock.length === 0) {
                    return;
                }

                if (this.model.get('pricingCalcItem').hasOption(OptionModel.NAME_MAILING_SERVICE)) {
                    this.$mailingServiceContainer.show();
                    this.$mailingServiceSwitchBlock.show();
                    this.updateMailingServiceOption();
                    this.$mailingServiceBlock.show();
                } else {
                    this.$mailingServiceBlock.hide();
                    this.$mailingServiceContainer.hide();
                    this.$mailingServiceSwitchBlock.hide();
                    this.cleanMailingServiceForce();
                    this.mailingServiceWidgetView.hide(true);
                }
            },

            updateMailingServiceOptionNewProduct: function() {
                if (this.$mailingServiceSwitch.prop('checked')) {
                    this.mailingServiceWidgetView.show(true);
                    this.mailingServiceWidgetView.resizeMailingClass();
                    storage.getInstance().setItem(OptionModel.NAME_MAILING_SERVICE, true);
                } else {
                    this.mailingServiceWidgetView.hide(true);
                    this.mailingServiceWidgetView.clearQuantity();
                    this.mailingServiceWidgetView.renderQuantity();
                    storage.getInstance().removeItem(OptionModel.NAME_MAILING_SERVICE);
                }
            },

            getMailingServiceValue: function() {
                var value = this.$mailingServiceSelect.val();

                if (typeof value == 'undefined') {
                    value = this.$mailingServiceSwitch.is(':checked')
                        ? OptionValueModel.NAME_MAILING_SERVICE
                        : OptionValueModel.NAME_NONE_MAILING_SERVICE;
                }

                return value;
            },

            updateMailingServiceOption: function() {
                var value = this.getMailingServiceValue();
                if (value === OptionValueModel.NAME_MAILING_SERVICE) {
                    this.mailingServiceWidgetView.show(true);
                    storage.getInstance().setItem(OptionModel.NAME_MAILING_SERVICE, true);
                    this.mailingServiceWidgetView.resizeMailingClass();
                } else {
                    this.mailingServiceWidgetView.hide(true);
                    storage.getInstance().removeItem(OptionModel.NAME_MAILING_SERVICE);
                }
                this.model.trigger('pricingCalcItem:changeOption', OptionModel.NAME_MAILING_SERVICE, value);
                this.updateDelivery();
            },

            updateDelivery: function() {
                //hide delivery widget if all items will be mailed
                var skuQuantity = this.model
                    .get('pricingCalcItem')
                    .getSelectedSku()
                    .get('sku')
                    .get('quantity');
                var mailingQuantity = this.model.get('mailingService').get('quantity');
                var mailingService = this.getMailingServiceValue();
                if (mailingQuantity == skuQuantity && mailingService === OptionValueModel.NAME_MAILING_SERVICE) {
                    this.$el.find('#delivery-container').slideUp();
                } else {
                    this.$el.find('#delivery-container').slideDown();
                }
            }
        });
    }
);
